export const siteData = {
  brand: "BIGGIE POPPINS",
  monogram: "BP",
  eyebrow: "V3A · editorial luxury study",
  tagline: "A quieter, more refined home for taste, systems, and selected work.",
  intro: "Still in motion. Just framed with more restraint, more air, and a little more permanence.",
  ctas: {
    primary: { label: "Enter selected work", href: "#portfolio" },
    secondary: { label: "Instagram", href: "https://instagram.com/BiggiePoppins" }
  },
  socials: [
    { name: "Instagram", url: "https://instagram.com/BiggiePoppins", icon: "Instagram" },
    { name: "Crafty Systems Labs", url: "https://github.com/Crafty-Systems-Labs", icon: "Github" }
  ],
  signalStrip: ["selected work", "systems", "writing", "craft"],
  about: {
    title: "QUIETLY AUTHORITATIVE",
    paragraphs: [
      "This direction leans more editorial: less heat, more poise. It treats the site like a publication cover crossed with a personal ledger.",
      "The signal is still yours — AI, commerce, systems, creative work — but presented with a little more elegance and patience."
    ],
    principles: [
      { title: "Taste with restraint", body: "Luxury here means confidence without noise." },
      { title: "Fewer, better signals", body: "Less clutter. More room for the right things to breathe." },
      { title: "Built to age well", body: "This version wants to feel timeless, not trendy." }
    ]
  },
  portfolio: [
    { id: 1, title: "Selected systems", description: "A calmer frame for tools, workflows, and operating structures that compound over time.", category: "Systems", status: "Curated", tags: ["clarity", "compound", "judgment"] },
    { id: 2, title: "Brand worlds", description: "Consumer ideas with stronger identity, cleaner ritual, and more elegant offer design.", category: "Brand", status: "Shaping", tags: ["identity", "ritual", "retention"] },
    { id: 3, title: "Writing in reserve", description: "Essays, notes, and fragments held until they feel precise enough to publish.", category: "Writing", status: "Private", tags: ["notes", "editing", "signal"] },
    { id: 4, title: "Visual authorship", description: "Photography and direction used sparingly — enough to deepen the world, never to overexplain it.", category: "Creative", status: "Occasional", tags: ["image", "mood", "presence"] },
    { id: 5, title: "Commercial taste", description: "The side of business that lives in selection, framing, and knowing what not to make.", category: "Commerce", status: "Active", tags: ["offers", "positioning", "taste"] },
    { id: 6, title: "Personal operating frame", description: "Health, discipline, and rhythm as part of the work — not separate from it.", category: "Operator", status: "Always on", tags: ["discipline", "energy", "reps"] }
  ],
  blog: [
    { id: 1, title: "Why restraint reads stronger than noise", excerpt: "A site does not need to shout to feel expensive or earned.", category: "Possible essay" },
    { id: 2, title: "On taste as a business advantage", excerpt: "Selection is not decoration. It changes what people trust.", category: "Possible essay" },
    { id: 3, title: "The case for slower publishing", excerpt: "Not every thought deserves to go live the minute it appears.", category: "Possible essay" }
  ],
  contact: {
    title: "START WITH THE SIGNAL",
    blurb: "This version would likely point people toward the cleanest public touchpoints first — Instagram for atmosphere, Crafty Systems Labs for body of work.",
    availability: [
      "Brand and positioning conversations",
      "Selected product/system collaborations",
      "Work that benefits from restraint instead of hype"
    ]
  }
};
